import { Modal, Button } from 'react-bootstrap'
import { t } from '../locale'

export function ValidationModal({
  open,
  onHide,
  field,
}: {
  open: boolean
  onHide: () => void
  field: string
}) {
  const isInvalidDate = field === t('invalidDate')

  return (
    <Modal show={open} onHide={onHide} centered backdrop='static' scrollable>
      <Modal.Header closeButton>
        <Modal.Title className='h4 justify-content-center'>
          {isInvalidDate ? t('invalidDate') : t('fieldValidationTitle')}
        </Modal.Title>
      </Modal.Header>

      {!isInvalidDate && (
        <Modal.Body>
          <h5 className='modal-body text-center'>{field}</h5>
        </Modal.Body>
      )}

      <Modal.Footer className='border-0 justify-content-center'>
        <Button variant='collapse' className='bg-collapse' onClick={onHide}>
          {t('ok')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
